import { render, staticRenderFns } from "./ConsumablesCategorical.vue?vue&type=template&id=7923873e"
import script from "./ConsumablesCategorical.vue?vue&type=script&lang=js"
export * from "./ConsumablesCategorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports